import { useEffect, useState } from 'react';

import { IGetTokenResponse, fetchTokenInfo } from '../request';
import { AUTH_TYPES, AuthTypes } from '../types';

type AuthDataType = {
  authType?: AuthTypes;
  isAuth: boolean;
  userData?: IGetTokenResponse;
};

export const useAuthData = () => {
  const [authData, setAuthData] = useState<AuthDataType>({
    authType: undefined,
    userData: undefined,
    isAuth: false,
  });

  useEffect(() => {
    fetchTokenInfo()
      .then((data) => {
        setAuthData({
          authType: data?.View?.tokenType ?? AUTH_TYPES.Captcha,
          userData: data,
          isAuth: !!data?.View?.token,
        });
      })
      .catch(() => {});
  }, []);

  return authData;
};
